import { useRef, useState } from 'react';
import styled, { css, type RuleSet } from 'styled-components';
import { BorderRadiusMedium, ColorNordicGrey4, Spacing16 } from 'autogen/design-tokens/tokens';
import type { ProductTabBlock } from 'autogen/swagger/all';
import { Body } from 'components/generic/typography';
import useIsOverflowing from 'hooks/globals/useIsOverflowing';
import Accordion from './Accordion';
import TabContent from './TabContent';

const previewLines = 3;

const Wrapper = styled.div<{ $highlightBackground: boolean }>`
    margin-bottom: ${Spacing16};
    ${({ $highlightBackground }): RuleSet | null =>
        $highlightBackground
            ? css`
                  padding: ${Spacing16};
                  background-color: ${ColorNordicGrey4};
                  border-radius: ${BorderRadiusMedium};
              `
            : null}
`;

const StyledBody = styled(Body)`
    margin-bottom: 0;
`;

export default function TabBlock({ ...props }: ProductTabBlock): JSX.Element {
    const { content, showAllText, headline, highlightBackground } = props;
    const contentRef = useRef<HTMLDivElement>(null);
    const [collapsed, setCollapsed] = useState(true);
    const isOverflowing = useIsOverflowing(contentRef, false);

    return (
        <Wrapper $highlightBackground={highlightBackground}>
            {headline && (
                <StyledBody size="M" strong>
                    {headline}
                </StyledBody>
            )}
            {showAllText && <TabContent content={content} collapsed={false} />}
            {!showAllText &&
                (isOverflowing ? (
                    <Accordion collapsed={collapsed} setCollapsed={setCollapsed} previewLines={previewLines}>
                        <TabContent content={content} collapsed={collapsed} />
                    </Accordion>
                ) : (
                    <TabContent content={content} ref={contentRef} collapsed />
                ))}
        </Wrapper>
    );
}
